import Vue from "vue";
import VueRouter from "vue-router";
import Authentication from "@/services/Authentication";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "LoginPage",
    component: () => import("@/pages/LoginPage.vue"),
  },
  {
    path: "/EsqueciASenha",
    name: "EsqueciASenha",
    component: () => import("@/pages/EsqueciASenha.vue"),
  },
  {
    path: "/boleto/:id",
    name: "",
    component: () => import("@/pages/boleto.vue"),
  },
  {
    path: "/",
    name: "",
    component: () => import("@/pages/IndexPage.vue"),
    children: [
      {
        name: "Home",
        path: "",
        component: () => import("@/pages/HomePage.vue"),
      },
      //   {
      //     name: "",
      //     path: "/produtos/:id",
      //     component: () => import("@/pages/produtos/Produtos.vue"),
      //   },
      {
        name: "Negativacao Listar",
        path: "/negativacao/Listar",
        component: () => import("@/pages/Negativacao/ListarNegativacao.vue"),
      },
      {
        name: "Novo Negativacao",
        path: "/negativacao/novo",
        component: () =>
          import("@/pages/Negativacao/Cadastro/CadastroNegativacao.vue"),
      },
      {
        nome: "Editar Negativacao",
        path: "negativacao/editar/:codigo",
        component: () =>
          import("@/pages/Negativacao/Cadastro/CadastroNegativacao.vue"),
      },
      {
        name: "",
        path: "/consumo",
        component: () => import("@/pages/ConsumoPage.vue"),
      },
      {
        name: "",
        path: "/faturas",
        component: () => import("@/pages/FaturasPage.vue"),
      },
      {
        name: "listarUsuarios",
        path: "/listarUsuarios/:codigo",
        component: () => import("@/pages/usuario/listarUsuarios.vue"),
      },
      {
        name: "reiniciarSenha",
        path: "/reiniciarSenha",
        component: () => import("@/pages/ReiniciarSenha.vue"),
      },
      {
        name: "",
        path: "/prePago",
        component: () => import("@/pages/PrePagoPage.vue"),
      }, 
      {
        name: "produtosGrupo",
        path: "/produtos/:grupo",
        component: () => import("@/pages/produtos/ProdutosGrupo.vue"),
        children: [
          {
            name: "produto",
            path: "/produtos/:grupo/:id",
            component: () => import("@/pages/produtos/Produtos.vue"),
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name == "LoginPage") {
    next();
    return;
  }

  if (to.name == "EsqueciASenha") {
    next();
    return;
  }

  if (Authentication.getToken() == null) {
    // explicitly return false to cancel the navigation

    console.log(Authentication.getToken() );
    next("/Login");
  }

  if (Authentication.tokenExpired()) {
    // explicitly return false to cancel the navigation
    next("/Login");
  }

  var dataToken = Authentication.getDataToken();

  if (dataToken.deveAlterarSenha === "True" && to.name != "reiniciarSenha") {
    next("/reiniciarSenha");
  }

  next();
});

export default router;
